module.exports = __webpack_public_path__ + "static/media/association_ind_member_badge.2f149c91.svg";